import { forwardRef, type Ref, type SVGProps } from "react";
const IconMessageOutlineSVG = (
  { children, ...rest }: SVGProps<SVGSVGElement>,
  ref: Ref<SVGSVGElement>
) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    aria-hidden="true"
    viewBox="0 0 32 32"
    ref={ref}
    {...rest}
  >
    {children}
    <path d="M27 4H5a3 3 0 0 0-3 3v12a3 3 0 0 0 3 3h3v6a1 1 0 0 0 0 .4 1 1 0 0 0 .6.5 1 1 0 0 0 .8 0 1 1 0 0 0 .3-.2l6.7-6.7H27a3 3 0 0 0 3-3V7a3 3 0 0 0-3-3m1 15a1 1 0 0 1-1 1H16a1 1 0 0 0-.7.3L10 25.6V22a2 2 0 0 0-2-2H5a1 1 0 0 1-1-1V7a1 1 0 0 1 1-1h22a1 1 0 0 1 1 1z" />
  </svg>
);
const ForwardRef = forwardRef(IconMessageOutlineSVG);
ForwardRef.displayName = "IconMessageOutline";
export { ForwardRef as IconMessageOutline };
